import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, first, map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-create-tablo-demo-session-redirect',
    templateUrl: './create-tablo-demo-session-redirect.component.html',
    styleUrls: ['./create-tablo-demo-session-redirect.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateTabloDemoSessionRedirectComponent implements OnInit {
  private static readonly CREATE_OR_GET_TABLO_DEMO_SESSION = gql`
    mutation createOrGetTabloDemoSession($organizationId: ID!) {
      createOrGetTabloDemoSession(organizationId: $organizationId)
    }
  `;

  constructor(
    private organization: OrganizationService,
    private apollo: Apollo,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.organization
      .getCurrentOrganization()
      .pipe(
        first(),
        switchMap((organizationId) =>
          this.apollo.mutate<{ createOrGetTabloDemoSession: string }>({
            mutation:
              CreateTabloDemoSessionRedirectComponent.CREATE_OR_GET_TABLO_DEMO_SESSION,
            variables: { organizationId },
            context: {
              serialize: 'public-session',
            },
          }),
        ),
        map((res) => res?.data?.createOrGetTabloDemoSession),
        catchError(() => of(null)),
        first(),
      )
      .subscribe((publicSessionId) => {
        if (!publicSessionId) {
          this.router.navigate(['/public-sessions/list']);
          return;
        }
        this.router.navigate(['/public-sessions/edit', publicSessionId, 'tablo']);
      });
  }
}
